var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","fill":"#4A4A4A","transform":"matrix(2.5592 0 0 2.5592 14.763 6.5171)","sketchType":"MSLayerGroup"},React.createElement("path",{"transform":"matrix(1 0 0 -1 0 14.444)","d":"m.2145 6.7086c-.286.28889-.286.75432 0 1.0272l6.4032 6.4682c.31778.32099.82622.32099 1.144 0s.31778-.83457 0-1.1556l-5.2592-5.3122c-.286-.28889-.286-.75432 0-1.0272l5.2592-5.3123c.31778-.32099.31778-.83457 0-1.1556-.31778-.32099-.82622-.32099-1.144 0l-6.4032 6.4679z","sketchType":"MSShapeGroup"})));
}

ChevronLeft.displayName = "ChevronLeft";

ChevronLeft.defaultProps = {"xmlnsSketch":"http://www.bohemiancoding.com/sketch/ns","xmlnsRdf":"http://www.w3.org/1999/02/22-rdf-syntax-ns#","height":"50","width":"50","version":"1.1","xmlnsCc":"http://creativecommons.org/ns#","viewBox":"0 0 50 50","xmlnsDc":"http://purl.org/dc/elements/1.1/"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;



//////////////////
// WEBPACK FOOTER
// ./src/app/icons/chevron-left.svg
// module id = 823
// module chunks = 0